var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.706,
    height: 36.958,
    viewBox: "0 0 36.706 36.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "basket",
    d: "M24.065,31.526a1.842,1.842,0,0,0,1.842-1.842V26a1.842,1.842,0,1,0-3.684,0v3.684A1.842,1.842,0,0,0,24.065,31.526Zm-7.368,0a1.842,1.842,0,0,0,1.842-1.842V26a1.842,1.842,0,1,0-3.684,0v3.684A1.842,1.842,0,0,0,16.7,31.526Zm16.577-22.1H30.732L27.546,3.068a1.842,1.842,0,1,0-3.279,1.658l2.339,4.7H14.155l2.339-4.7a1.842,1.842,0,0,0-3.279-1.658L10.029,9.423H7.488A5.526,5.526,0,0,0,5.793,20.18L7.156,33.92a5.526,5.526,0,0,0,5.526,4.973H28.117a5.526,5.526,0,0,0,5.526-4.973L35.005,20.18A5.526,5.526,0,0,0,33.274,9.423ZM29.94,33.552A1.842,1.842,0,0,1,28.1,35.209H12.663a1.842,1.842,0,0,1-1.842-1.658L9.514,20.474H31.248ZM33.274,16.79H7.488a1.842,1.842,0,1,1,0-3.684H33.274a1.842,1.842,0,1,1,0,3.684Z",
    transform: "translate(-2.045 -1.935)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.63f6503c580e7ad3aa8d2a692e6c1655.svg";
export { ForwardRef as ReactComponent };